import { Page } from './page.model';

export class CompletedSurvey {
  IdElaborazioneCompilativa: number
  Pages: Page[] = []
  isCompleted: boolean
}
